function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f3cb4d;}.cls-2{fill:#3975bb;}.cls-3{fill:#e11d3f;}.cls-4{fill:#231f20;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "newyear-hat");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M68.76,32.8L45.58,100.45s26.79,17.91,57.71-5.09Z",
  transform: "translate(-43.45 -28.87)"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "14.07 63.37 10.6 62.11 12.01 65.55 8.06 68.1 12.46 68.17 15.16 71.78 16.02 68.11 19.95 67.63 16.95 65.2 17.77 61.41 14.07 63.37"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "42.96 51.1 41.59 47.67 39.96 51.01 35.43 49.75 38.3 53.08 37.4 57.5 40.71 55.71 43.68 58.32 43.5 54.47 46.88 52.56 42.96 51.1"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "43.44 74.38 47.14 74.62 44.82 71.71 47.89 68.16 43.66 69.32 40.05 66.61 40.25 70.37 36.62 71.94 40.18 73.42 40.45 77.29 43.44 74.38"
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "36.4 24.84 36.27 21.14 33.61 23.73 29.77 21.02 31.34 25.12 29.01 28.98 32.73 28.41 34.65 31.87 35.77 28.18 39.6 27.53 36.4 24.84"
});

var _ref9 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "23.34 40.8 20.38 38.58 20.73 42.28 16.21 43.57 20.39 44.92 21.93 49.16 23.82 45.9 27.72 46.58 25.55 43.39 27.44 40 23.34 40.8"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M68.23,28.87l-24.78,72s28.19,20.44,61.35-5.88ZM46.34,99.59l22.51-65,32.73,60.17C71.5,116.43,46.34,99.59,46.34,99.59Z",
  transform: "translate(-43.45 -28.87)"
});

var SvgNewYear = function SvgNewYear(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "new_year",
    "data-name": "new year",
    viewBox: "0 0 61.35 79.52",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewYear, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new-year.06a18849.svg";
export { ForwardRef as ReactComponent };